import Vue from 'vue'
import Vuex from 'vuex'

import userModule from "./modules/user";

import {USER_NS} from "@/store/modules/user/constants";


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        [USER_NS]: userModule,
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js